import React, { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  redirect,
} from "react-router-dom";
import PageLoader from "../component/loader/PageLoader";
import ErrorBoundary from "./ErrorBoundary";
import HomeLayout from "./HomeLayout";
import Signin from "../component/Signin";
import { URL } from "../util/helper";
import Record from "../component/Record";
import Staff from "../component/Staff";
import CustomerServicePage from "../component/CustomerServicePage";
import About from "../component/About";
import Contact from "../component/Contact";

// Lazy-loaded components
const Home = lazy(() => import("../component/Home"));
const Service = lazy(() => import("../component/ServicePage"));
const Dashboard = lazy(() => import("../component/Dashboard"));
const CustomerDashboard = lazy(() => import("../component/CustomerDashboard"));

const checkAuth = async () => {
  const token = localStorage.getItem("myToken");
  if (!token) {
    return false;
  }

  try {
    const response = await fetch(`${URL}/auth/verifyToken`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.ok;
  } catch {
    return false;
  }
};

const protectedLoader = async () => {
  const isAuthenticated = await checkAuth();
  if (!isAuthenticated) {
    return redirect("/home");
  }
  return null;
};

const customerProtectedLoader = async () => {
  const token = localStorage.getItem("customerToken");
  if (!token) {
    return redirect("/home");
  }

  try {
    // In a real implementation, you would verify the token with your backend
    // For now, we'll just check if it exists and return null to allow access
    console.log("Customer token found, allowing access");
    return null;
  } catch {
    console.log("Invalid customer token");
    return redirect("/home");
  }
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/home" replace />,
  },

  {
    path: "/home",
    element: <HomeLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "*",
        element: <Navigate to="/home" replace />,
      },
      {
        path: "menu/:id",
        element: <Service />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },

  {
    path: "/signin",
    element: <Signin />,
    errorElement: <ErrorBoundary />,
  },

  {
    path: "dashboard",
    element: <Dashboard />,
    loader: protectedLoader,
  },
  {
    path: "staff",
    element: <Staff />,
    loader: protectedLoader,
  },
  {
    path: "customer-service",
    element: <CustomerServicePage />,
    // loader: protectedLoader,
  },
  {
    path: "customer",
    element: <CustomerDashboard />,
    loader: customerProtectedLoader,
  },
  {
    path: "record/:id",
    element: <Record />,
    loader: customerProtectedLoader,
  },
  {
    path: "*",
    element: <Navigate to="/home" replace />,
  },
]);

const AppRouters = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default AppRouters;
